var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"85vh","display":"flex","flex-direction":"column","justify-content":"center","align-items":"center"}},[_c('h3',[_vm._v(_vm._s(_vm.fileName))]),_c('div',{staticStyle:{"margin-top":"20px","margin-bottom":"20px"}},[_c('DownloadButton',{attrs:{"url":_vm.url}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }